import { useQuery } from "@tanstack/react-query";

import { api } from "@utils/api";

import { useQueryErrorHandling } from "@hooks/useQueryErrorHandling";

import { DashboardQueryProps, StaffPerformance } from "@customTypes/dashboard";

import { dashboardQKeys } from "./queryKeys";


const select = (res: any) => {
  //   console.log(res.data);
  const newData: StaffPerformance[] = [];

  if (Object.keys(res.data).length) {
    for (const i in res.data.data) {
      const {
        name,
        role,
        labs_completed,
        labs_ordered,
        labs_assisted,
        prescriptions,
        medications,
        consultations,
        earnings, // Not yet implemented on backend
      } = res.data.data[i];
      newData.push({
        name,
        roles: role,
        prescriptions,
        medications,
        consultations,
        labsCompleted: labs_completed,
        labsAssisted: labs_assisted,
        labsOrdered: labs_ordered,
        earnings,
      });
    }

    return newData;
  }

  return null;
};

export const useGetStaffPerformance = ({
  dateRange,
  startDate,
  endDate,
}: DashboardQueryProps) => {
  const handleErrors = useQueryErrorHandling();

  return useQuery({
    queryKey: dashboardQKeys.staffPerformanceWithFilters({
      dateRange,
      startDate,
      endDate,
    }),
    queryFn: () => {
      return api.get("analytics/staff/performance", {
        params: {
          range: dateRange?.replaceAll("-", "_"),
          ...(dateRange === "custom" && {
            start_date: startDate,
            end_date: endDate,
          }),
        },
      });
    },
    select,
    staleTime: 1000 * 60 * 5, // 5 minutes
    enabled:
      dateRange !== "custom" ||
      !!(dateRange === "custom" && startDate && endDate),

    onError: (res: any) => {
      console.error("[From Get Staff performance]", res);
      handleErrors(res, "query");
    },
  });
};
